
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNavigationRoute as ObiNavigationRouteElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-navigation-route.js';
 
 
 

 
 export const ObiNavigationRoute = createComponent({
   react: React,
   tagName: 'obi-navigation-route',
   elementClass: ObiNavigationRouteElement,
   events: {
     
   }
  });
 
 